import styled from 'styled-components';
// import {Link as LinkS } from 'react-scroll'
import { Link as LinkR } from 'react-router-dom';

import { HashLink as LinkS } from 'react-router-hash-link';

export const Nav = styled.nav`
  width: 100%;
  height: 88px;
  margin: 0;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: clamp(0.78rem, 1vw, 1rem);

  border-bottom: 1px solid #cdcdcd;
  @media screen and (max-width: 960px) {
    height: 64px;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(10px, 1.4vw, 24px);
  height: 100%;
  width: 100%;
  max-width: 1600px;
  padding: 0 clamp(12px, 2vw, 28px);
  margin: 0 auto;

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    gap: 8px;
    padding: 0 12px;
  }
`;
export const LogoBlock = styled.div`
  justify-self: flex-start;
  display: flex;
  align-items: center;
`;

export const NavLogo = styled(LinkS)`
  display: flex;
  cursor: pointer;
  text-decoration: none;
`;

export const MobileIcon = styled.button`
  display: none;
  margin-left: auto;
  border: 0;
  background: transparent;
  line-height: 1;

  @media screen and (max-width: 960px) {
    display: grid;
    place-items: center;
    cursor: pointer;
    color: black;
    font-size: 28px;
    padding: 8px;
  }
`;
export const NavMenu = styled.ul`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  gap: clamp(2px, 0.5vw, 10px);
  list-style: none;
  text-align: center;
  margin: 0;
  padding: 0;
  font-size: calc(1em + 2px);

  @media screen and (max-width: 960px) {
    display: none;
  }

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    gap: 0;
  }
`;
export const NavItem = styled.li`
  height: 100%;
`;
export const NavLink = styled(LinkS)`
  color: #000;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 clamp(0.4rem, 0.75vw, 0.85rem);
  height: 100%;
  cursor: pointer;
  font-weight: 600;

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    padding: 0 0.3rem;
  }
  /* 
    &.active{
        border-bottom: 5px #ff5500 solid;
        transition:.1s ease;
    } */
`;
export const NavLinkR = styled(LinkR)`
  color: #000;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 clamp(0.4rem, 0.75vw, 0.85rem);
  height: 100%;
  cursor: pointer;
  font-weight: 600;

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    padding: 0 0.3rem;
  }
`;

export const NavBtn = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const NavLang = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin: 0;
  padding: 0;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const LangItem = styled.li`
  width: 28px;
  cursor: pointer;
  margin-left: 5px;

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    width: 24px;
    margin-left: 3px;
  }
`;

export const LangImg = styled.img`
  width: 100%;
  height: 100%;
`;

export const LogoImage = styled.img`
  width: clamp(145px, 15vw, 220px);
  height: auto;

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    width: 135px;
  }

  @media screen and (max-width: 520px) {
    width: clamp(115px, 36vw, 150px);
  }
`;

export const InnioLink = styled.a`
  display: flex;
`;
export const InnioImage = styled.img`
  width: clamp(110px, 12vw, 170px);
  height: auto;

  @media screen and (min-width: 961px) and (max-width: 1200px) {
    width: 95px;
  }

  @media screen and (max-width: 520px) {
    width: clamp(80px, 25vw, 105px);
  }
`;
